module.exports = __webpack_public_path__ + "static/p3-d0b73975e47ebc64bc3bca2fdbbe15be.png";